import React from "react";
import { SectionDivider, FrameCorners } from "@/components/Ornaments";
import Header from "@/components/Header";
import InvitationText from "@/components/InvitationText";
import CouplePhotos from "@/components/CouplePhotos";
import MusicPlayer from "@/components/MusicPlayer";
import EventDetails from "@/components/EventDetails";
import Rsvp from "@/components/Rsvp";
import Calendar from "@/components/Calendar";
import FloatingButton from "@/components/FloatingButton";

const Invitation = ({ data, revealed }) => {
  return (
    <main
      className={`relative z-[1] mx-auto max-w-md px-4 py-8 transition-opacity duration-700 sm:max-w-lg sm:py-12 ${
        revealed ? "opacity-100" : "opacity-0"
      }`}
      aria-hidden={!revealed}
    >
      <div className="invite-frame space-y-12 px-6 py-12 sm:px-10">
        <FrameCorners />
        <Header data={data} />
        <SectionDivider />
        <InvitationText data={data} />
        <SectionDivider />
        <CouplePhotos data={data} />
        <SectionDivider />
        <MusicPlayer data={data} />
        <SectionDivider />
        <EventDetails data={data} />
        <SectionDivider />
        <Rsvp />
        <SectionDivider />
        <Calendar data={data} />
      </div>
      <FloatingButton />
    </main>
  );
};

export default Invitation;
